// import PlayArrowIcon from "@mui/icons-material/PlayArrow";
// import PauseCircleIcon from "@mui/icons-material/PauseCircle";
// import UnarchiveIcon from "@mui/icons-material/Unarchive";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import WarehouseIcon from '@mui/icons-material/Warehouse';

// import CancelIcon from "@mui/icons-material/Cancel";

// // Status mapping from API to display
// export const STATUS_MAPPING = {
//   inProgress: "In Progress",
//   paused: "Paused",
//   unload: "Unloaded",
//   inTransit: "In Transit",
//   dropToDepo: "Drop To Depo",
//   readyForDelivery: "Ready for Delivery",
//   delivered: "Delivered",
//   canceled: "Canceled",
// };

// // Helper function to map API status to display status
// export const mapStatus = (apiStatus) => {
//   return STATUS_MAPPING[apiStatus] || apiStatus;
// };

// // Define status steps
// export const STATUS_STEPS = [
//   { label: "In Progress", icon: PlayArrowIcon },
//   { label: "Paused", icon: PauseCircleIcon },
//   { label: "Unloaded", icon: UnarchiveIcon },
//   { label: "Ready for Delivery", icon: DeliveryDiningIcon },
//   { label: "In Transit", icon: LocalShippingIcon },
//   { label: "Drop To Depo", icon: WarehouseIcon },
//   { label: "Delivered", icon: CheckCircleIcon },
//   { label: "Canceled", icon: CancelIcon },
// ];

// // Status colors (using colors from ORDER_STATUSES constants where available)
// export const getStatusColor = (status) => {
//   const colors = {
//     Picked: "#00897B", // Custom color - Teal to distinguish from all other statuses
//     "In Progress": "#2196F3", // From ORDER_STATUSES
//     Paused: "#FF9800", // From ORDER_STATUSES
//     Unloaded: "#9C27B0", // Purple to distinguish unloaded state
//     "Ready for Delivery": "#00BCD4", // From ORDER_STATUSES
//     "In Transit": "#3F51B5",
//      // From ORDER_STATUSES
//     "Drop To Depo" : "#707e1d",
//     Delivered: "#4CAF50", // Using Completed color from ORDER_STATUSES
//     Canceled: "#F44336", // From ORDER_STATUSES
//   };
//   return colors[status] || "#757575";
// };


// ***********************************************************************************************************************

import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarehouseIcon from '@mui/icons-material/Warehouse';
import DirectionsRailwayIcon from "@mui/icons-material/DirectionsRailway";
import CancelIcon from "@mui/icons-material/Cancel";

// Status mapping from API to display
export const STATUS_MAPPING = {
  inProgress: "In Progress",
  paused: "Paused",
  unload: "Unloaded",
  inTransit: "In Transit",
  dropToDepo: "Drop To Depo",
  loaded: "Loaded", // Changed from "Ready for Delivery" to "Loaded"
  delivered: "Delivered",
  canceled: "Canceled",
};

// Helper function to map API status to display status
export const mapStatus = (apiStatus) => {
  return STATUS_MAPPING[apiStatus] || apiStatus;
};

// Define status steps
export const STATUS_STEPS = [
  { label: "In Progress", icon: PlayArrowIcon },
  { label: "Paused", icon: PauseCircleIcon },
  { label: "Unloaded", icon: UnarchiveIcon },
  { label: "Loaded", icon: DirectionsRailwayIcon }, // Changed from "Ready for Delivery" to "Loaded"
  { label: "In Transit", icon: LocalShippingIcon },
  { label: "Drop To Depo", icon: WarehouseIcon },
  { label: "Delivered", icon: CheckCircleIcon },
  { label: "Canceled", icon: CancelIcon },
];

// Status colors (using colors from ORDER_STATUSES constants where available)
export const getStatusColor = (status) => {
  const colors = {
    Picked: "#00897B", // Custom color - Teal to distinguish from all other statuses
    "In Progress": "#2196F3", // From ORDER_STATUSES
    Paused: "#FF9800", // From ORDER_STATUSES
    Unloaded: "#9C27B0", // Purple to distinguish unloaded state
    "Loaded": "#00BCD4", // Changed from "Ready for Delivery" to "Loaded", keeping the same color
    "In Transit": "#3F51B5",
    "Drop To Depo" : "#707e1d",
    Delivered: "#4CAF50", // Using Completed color from ORDER_STATUSES
    Canceled: "#F44336", // From ORDER_STATUSES
  };
  return colors[status] || "#757575";
};